import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Flex, Text, TEXT_VARIANT_LIGHT } from 'mailup-web-components'

import * as S from './WorkflowBuilder.styles'

const ChangeEmailStatusItem = ({
  EmailStatusCondition,
  EmailStatus,
  draggableId,
  currentDragItem
}) => {
  const intl = useIntl()

  const statusLabels = {
    OptIn: intl.formatMessage({ id: 'Load.MailupCommon.Subscribed' }),
    Pending: intl.formatMessage({ id: 'Load.MailupCommon.Pending' }),
    OptOut: intl.formatMessage({ id: 'Load.MailupCommon.Unsubscribed' })
  }

  return (
    <S.InnerItem>
      {currentDragItem !== draggableId && <S.ItemHorizontalLine />}
      <S.ItemCircle>
        {currentDragItem !== draggableId && <S.Circle />}
      </S.ItemCircle>
      <S.WorkflowBuilderItem>
        <S.ItemLeft>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.DragElementChangeSubscriptionStatus'
          })}
        </S.ItemLeft>
        <S.ItemRight>
          <Flex gap='8px' height='100%' alignItems='center'>
            <Text variant={TEXT_VARIANT_LIGHT}>
              {intl.formatMessage(
                {
                  id: 'Load.AutomationWorkflow.ChangeSubscriptionDescription'
                },
                {
                  CONDITIONSTATUS: (
                    <strong>{statusLabels[EmailStatusCondition]}</strong>
                  ),
                  STATUS: <strong>{statusLabels[EmailStatus]}</strong>
                }
              )}
            </Text>
          </Flex>
        </S.ItemRight>
      </S.WorkflowBuilderItem>
    </S.InnerItem>
  )
}

ChangeEmailStatusItem.propTypes = {
  draggableId: PropTypes.string,
  currentDragItem: PropTypes.string,
  EmailStatusCondition: PropTypes.oneOf(['OptIn', 'Pending', 'OptOut']),
  EmailStatus: PropTypes.oneOf(['OptIn', 'Pending', 'OptOut'])
}

export default ChangeEmailStatusItem
